const ne = (a, b) => {
	// eslint-disable-next-line eqeqeq
	return a != b;
};

export default ne;
